module.exports = __webpack_public_path__ + "fa-brands-400.e8c322de9658cbeb8a77.woff2";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/src/assets/plugins/FontAweson/webfonts/fa-brands-400.woff2
// module id = ../../../../../src/assets/plugins/FontAweson/webfonts/fa-brands-400.woff2
// module chunks = styles